import * as types from "../constants/ActionTypes";

const initialState = {
  initial: new Date().setDate(new Date().getDate() - 30),
  final: new Date(),
};

const dateOfFilterQuarentine = (state = initialState, action) => {
  switch (action.type) {
    case types.EDIT_INITIAL_DATE_FILTER_QUARENTINE:
      return {
        initial: action.initial,
        final: state.final,
      };
    case types.EDIT_FINAL_DATE_FILTER_QUARENTINE:
      return {
        initial: state.initial,
        final: action.final,
      };
    default:
      return state;
  }
};

export default dateOfFilterQuarentine;
